import {
  TKwikUIButtonAppearance,
  TKwikUIButtonShape,
  TKwikUIButtonSize,
  TKwikUIButtonType,
  VKwikUIButtonAppearance,
  VKwikUIButtonShape,
  VKwikUIButtonSize,
  VKwikUIButtonType
} from "./button.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    appearance: (x: TKwikUIButtonAppearance) =>
      VKwikUIButtonAppearance.includes(x),
    class: isString,
    disabled: isBoolean,
    icon: isString,
    iconRight: isString,
    id: isString,
    label: isString,
    shape: (x: TKwikUIButtonShape) => VKwikUIButtonShape.includes(x),
    showLoader: isBoolean,
    size: (x: TKwikUIButtonSize) => VKwikUIButtonSize.includes(x),
    styles: isString,
    type: (x: TKwikUIButtonType) => VKwikUIButtonType.includes(x)
  };

  return methods[key] && methods[key](value);
};
